import { createApiRef } from '@backstage/core-plugin-api';
import { DependencyResponse } from '../utils/types';

export interface DependencyViewerApi {
  getDependencies(projectSlug: string, manifestPaths?: string[]): Promise<DependencyResponse>;
  /**
   * Opens a streaming connection that progressively resolves dependency versions.
   * Calls `onUpdate` each time a batch of versions is resolved.
   * Returns an abort function to cancel the stream.
   */
  streamDependencies(
    projectSlug: string,
    manifestPaths: string[] | undefined,
    callbacks: StreamCallbacks,
  ): () => void;
  invalidateCache(projectSlug: string, manifestPaths?: string[]): void;
}

export interface StreamCallbacks {
  onManifests: (data: StreamManifestsEvent) => void;
  onBatch: (data: StreamBatchEvent) => void;
  onDone: (data: StreamDoneEvent) => void;
  onError: (error: Error) => void;
}

export interface StreamManifestsEvent {
  manifests: DependencyResponse['manifests'];
  dependencies: DependencyResponse['dependencies'];
  totalCount: number;
}

export interface StreamBatchEvent {
  updates: Array<{
    index: number;
    dependency: DependencyResponse['dependencies'][number];
  }>;
}

export interface StreamDoneEvent {
  summary: DependencyResponse['summary'];
}

export const dependencyViewerApiRef = createApiRef<DependencyViewerApi>({
  id: 'plugin.dependency-viewer.api',
});
